module.exports = __webpack_public_path__ + "img/undraw_Messages_re_qy9x.218a4295.svg";